/**
 * 删除评论
 * @param id 评论ID
 */
export async function requestDeleteComment(id: number) {
  return http.post('/v1/comment/delete', {
    comment_id: id
  })
}
